export default "__VITE_ASSET__DJxOf_Pp__"